import { render, staticRenderFns } from "./AddBlog.vue?vue&type=template&id=5678461f&"
import script from "./AddBlog.vue?vue&type=script&lang=js&"
export * from "./AddBlog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports